import { render, staticRenderFns } from "./VidaAvanza.vue?vue&type=template&id=46ab0f5f"
import script from "./VidaAvanza.vue?vue&type=script&lang=js"
export * from "./VidaAvanza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports